import React from 'react';
import { Table, Tag, Space, Avatar, Empty } from 'antd';
import { UserOutlined, CrownOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';
import { FormattedMessage } from 'react-intl';
import { Card } from '../../components/MarketerView/atoms';
import { THEME } from '../../components/MarketerView/config/theme';
import { AgencyPageHeader } from '../components/agencyUi';

export const AgencyTeamPage: React.FC = () => {
    const { user } = useAuth();

    // For now, show the current user. Full team management is a future feature.
    const teamMembers = user ? [{
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        roles: typeof user.roles === 'string' ? JSON.parse(user.roles) : user.roles,
    }] : [];

    const columns = [
        {
            title: <FormattedMessage id="agency.team.member" defaultMessage="Team Member" />,
            key: 'member',
            render: (_: any, record: any) => (
                <Space>
                    <Avatar style={{ backgroundColor: THEME.primary }} icon={<UserOutlined />} />
                    <div>
                        <div style={{ fontWeight: 600, color: THEME.textBase }}>
                            {record.firstName} {record.lastName}
                        </div>
                        <div style={{ fontSize: 12, color: THEME.textSecondary }}>
                            {record.email}
                        </div>
                    </div>
                </Space>
            ),
        },
        {
            title: <FormattedMessage id="agency.team.role" defaultMessage="Role" />,
            key: 'role',
            render: (_: any, record: any) => {
                const isAdmin = record.roles?.includes('AGENCY_ADMIN');
                return (
                    <Tag color={isAdmin ? 'gold' : 'blue'} icon={isAdmin ? <CrownOutlined /> : undefined}>
                        {isAdmin ? (
                            <FormattedMessage id="agency.team.admin" defaultMessage="Agency Admin" />
                        ) : (
                            <FormattedMessage id="agency.team.user" defaultMessage="Agency User" />
                        )}
                    </Tag>
                );
            },
        },
    ];

    return (
        <div>
            <AgencyPageHeader
                title={<FormattedMessage id="agency.team.title" defaultMessage="Team" />}
            />

            <Card pad={0} style={{ maxWidth: 720 }}>
                <Table
                    columns={columns}
                    dataSource={teamMembers}
                    rowKey="id"
                    pagination={false}
                    locale={{
                        emptyText: (
                            <Empty description={
                                <FormattedMessage id="agency.team.noMembers" defaultMessage="No team members found" />
                            } />
                        ),
                    }}
                />
            </Card>

            <p style={{ color: THEME.textMuted, fontSize: 13, marginTop: 16, maxWidth: 720 }}>
                <FormattedMessage
                    id="agency.team.managementNote"
                    defaultMessage="Team member management is coming soon. Contact support to add or remove agency users."
                />
            </p>
        </div>
    );
};
